import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import '../styles/RunComps.css';
import { Header, AllCompsMap, ImageGallery, ScrollableImages, PropertyCard, SelectedComps, PropertyCardDetail, MapLegend, Switch, SearchInput, PredictiveSearch, Button, CompsOverlay, Modal, Loading, IconButton, ReportLoadingAnimation, MobileSelectedComps, SmallChat, AgenticTimeline } from '../components';
import { checkOnAuthStateChanged, propertyGatewayString, cloudFunctionV2, sendErrorEmail, getDocument, getSubDocument, setSelectedPropertyTransaction, regenerateTimeline, setSelectedPropertyReportTransaction, setSubData, recordEvent, generateARV, setPropertyARVData, propertyGatewayStringReRun, generateAsIs, setPropertyAsIsData, getSubSubDocument, generateSubjectPropertyObject, generateSelectedCompsArray, updatePropertyARVMessages, minifyComps, startCompSelectionAgent, maxifyComps, makeId, queryATTOM, selectARVScenario, listenForARVMessages, getExclusionDescription } from '../functions';
import { useNavigate, useParams } from 'react-router-dom';
import { useJsApiLoader } from '@react-google-maps/api';
import { House, MagnifyingGlass, MapBubble } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { LicenseIcon, Location04Icon, ReloadIcon, Settings01Icon } from 'hugeicons-react';
import { ARVEstimateDescription, ARVEstimateHeading, CompTypeSelection, MissingComp, MobileSettings } from '../modalbody';
import { defaultSettings, propertyData } from '../defaults';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';


const libraries = process.env.REACT_APP_GOOGLE_LIBRARIES.split(',');

function RunComps() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [property, setProperty] = useState(null);
    const [allComps, setAllComps] = useState([]);
    const [filteredComps, setFilteredComps] = useState([]);
    const [bestComps, setBestComps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [companyId, setCompanyId] = useState(null);
    const [clickedZPID, setClickedZPID] = useState(null);
    const [viewImageGallery, setViewImageGallery] = useState(false);
    const [viewScrollableImages, setViewScrollableImages] = useState(false);
    const [imageViewProperty, setImageViewProperty] = useState(null);
    const [imageViewPropertyIndex, setImageViewPropertyIndex] = useState(0);
    const [selectedComps, setSelectedComps] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [detailedView, setDetailedView] = useState(null);
    const [qualifyingDescriptions, setQualifyingDescriptions] = useState([]);
    const [hoverZPID, setHoverZPID] = useState(null);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [neighbourhoodData, setNeighbourhoodData] = useState([]);
    const [tracts, setTracts] = useState([]);
    const [neighbourhoodBounds, setNeighbourhoodBounds] = useState([]);
    const [hoverMapLegend, setHoverMapLegend] = useState(null);
    const [showHeatmap, setShowHeatmap] = useState(false);
    const [selectedPanel, setSelectedPanel] = useState("all");
    const [compTypeDropdownOpen, setCompTypeDropdownOpen] = useState(null);
    const [linkCopied, setLinkCopied] = useState(false);
    const [linkCopiedError, setLinkCopiedError] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [address, setAddress] = useState("");
    const [suggestedComps, setSuggestedComps] = useState([]);
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [compsOverlayExpanded, setCompsOverlayExpanded] = useState(false);
    const [networkError, setNetworkError] = useState(false);
    const [mobileSettings, setMobileSettings] = useState(false);
    const [mapType, setMapType] = useState("roadmap");
    const [rawMap, setRawMap] = useState(null);
    const [arvLoading, setArvLoading] = useState(false);
    const [arvEstimate, setArvEstimate] = useState(null);
    const [arvRange, setArvRange] = useState(null);
    const [arvDescription, setArvDescription] = useState(null);
    const [subjectPropertyHover, setSubjectPropertyHover] = useState(false);
    const [showReRunReportModal, setShowReRunReportModal] = useState(false);
    const [reRunReportLoading, setReRunReportLoading] = useState(false);
    const [userId, setUserId] = useState(null);
    const [asIsEstimate, setAsIsEstimate] = useState(null);
    const [asIsDescription, setAsIsDescription] = useState(null);
    const [arvDescriptionModal, setArvDescriptionModal] = useState(false);
    const [arvDescriptionPrompt, setArvDescriptionPrompt] = useState("");
    const [arvMessages, setArvMessages] = useState([]);
    const [compsChanged, setCompsChanged] = useState(false);
    const [chatbotLoading, setChatbotLoading] = useState(false);
    const [textAreaHeight, setTextAreaHeight] = useState(36);
    const [compTypeModal, setCompTypeModal] = useState(false);
    const [compTypeSelectionVal, setCompTypeSelectionVal] = useState(null);
    const [keptComp, setKeptComp] = useState(null);
    const [typeOutText, setTypeOutText] = useState(true);
    const [regenerateARVErrorModal, setRegenerateARVErrorModal] = useState(false);
    const [smallChatExpanded, setSmallChatExpanded] = useState(false);
    const [smallChatHover, setSmallChatHover] = useState(false);
    const [missingCompModal, setMissingCompModal] = useState(false);
    const [missingCompDescription, setMissingCompDescription] = useState("");
    const [missingCompLoading, setMissingCompLoading] = useState(false);
    const [actionRequired, setActionRequired] = useState(false);
    const [scenarios, setScenarios] = useState(null);
    const [propertyNotes, setPropertyNotes] = useState("");
    const [adu, setAdu] = useState(false);
    const [pool, setPool] = useState(false);
    const [garage, setGarage] = useState(false);
    const [agenticSteps, setAgenticSteps] = useState([]);
    const [excludedZPIDs, setExcludedZPIDs] = useState([]);
    const [ceilings, setCeilings] = useState([]);
    const [anomaly, setAnomaly] = useState(null);
    const [redfinData, setRedfinData] = useState(null);
    const [conditionUpdate, setConditionUpdate] = useState([]);
    const agenticStepsRef = useRef([]);
    // Keep agenticStepsRef in sync with the latest state
    useEffect(() => {
        agenticStepsRef.current = agenticSteps;
    }, [agenticSteps]);
    const [streetViewAnalysis, setStreetViewAnalysis] = useState([]);
    const [showAgenticTimeline, setShowAgenticTimeline] = useState(true);
    // const [shareLinkModal, setShareLinkModal] = useState(false);
    // const [shareARVEstimate, setShareARVEstimate] = useState(true);
    // const [shareAsIsEstimate, setShareAsIsEstimate] = useState(true);

    const params = useParams();
    const navigate = useNavigate();
    const clickedComp = clickedZPID === null ? null : allComps[allComps.findIndex(e => e.uniqueIds.zillowId === clickedZPID)];
    const clickedCompDescriptionIndex = qualifyingDescriptions.findIndex(e => e.zpid === clickedZPID);
    const clickedCompDescription = clickedCompDescriptionIndex === -1 ? null : qualifyingDescriptions[clickedCompDescriptionIndex].description;
    const compsRef = useRef(null);
    const compsRefMobile = useRef(null);
    const mobileSelectedCompsBody = useRef(null);
    const fullSelectedComps = allComps.filter(e => selectedComps.findIndex(x => x.zpid === e.uniqueIds.zillowId) !== -1);
    const propertyId = params === null ? null : params.id;
    const countyId = params === null ? null : params.countyId;
    const readOnly = false;
    const darkBgActive = ((missingCompModal === true && innerWidth > 1000) || regenerateARVErrorModal === true || compTypeModal === true || arvDescriptionModal === true || detailedView !== null || showReRunReportModal === true || (innerWidth < 1000 && (mobileSettings === true)))
    const db = getFirestore();
    const bodyRef = useRef(null);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: JSON.parse(process.env.REACT_APP_GOOGLE).key,
        libraries: libraries
    });
    
    useEffect(() => {

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);

                const colRef = "users";
                const docRef = user.userId;
                const queryData = await getDocument(colRef, docRef);
                if ( queryData.status === 200 ) {
                    const data = queryData.data.data;
                    setCompanyId(data.companyId);
                    fetchPropertyData(user.userId, data.companyId);
                }
            }
            else {
                navigate("/sign-up", {
                    state: {
                        path: `/run-comps/${countyId}/${propertyId}`
                    }
                });
                setLoggedIn(false);
            }

            if ( user.status === 200 ) {
                setUserId(user.userId);
            }
        };

        const getMLSData = async(savedCompanyId, props) => {
            const getCompanyData = await getDocument("companies", savedCompanyId);
            if ( getCompanyData.status === 200 ) {
                const data = getCompanyData.data.data;
                if ( data.mlsData !== true && data.attom !== true ) {
                    return props;
                }
                else if ( data.mlsData === true ) {
                    for (let index = 0; index < props.length; index++) {
                        const element = props[index];
                        if ( element.addressDetails.state === "FL" ) {
                            break;
                        }
                        else if ( element.listingDetails.listingStatus === "for_sale" || element.listingDetails.listingStatus === "pending" ) {
                            continue;
                        }
                        const colRef = "mls_data";
                        const zipcode = element.addressDetails.postalCode;   
                        const subColRef = "properties";
                        const subDocRef = element.addressDetails.streetAddress.replaceAll("/", "");
                        const soldListingDate = props[index].listingDetails.soldListingDate;
                        const soldListingDateTS = new Date(soldListingDate);
                        const soldListingDateTSSeconds = Math.floor(soldListingDateTS.getTime() / 1000);

                        const queryData = await getSubSubDocument(colRef, savedCompanyId, "zipcodes", zipcode, subColRef, subDocRef);
                        if ( queryData.status === 200 ) {
                            const price = queryData.data.price;
                            const expiryDate = queryData.data.date;
                            const expiryDateSeconds = expiryDate.seconds
                            if ( soldListingDateTSSeconds < expiryDateSeconds ) {
                                props[index].mlsVerified = true;
                                props[index].listingDetails.soldListingPrice = price;
                            }
                        }
                    }
                    return props;
                }
                else if ( data.attom === true ) {
                    for (let index = 0; index < props.length; index++) {
                        const element = props[index];
                        if ( element.addressDetails.state === "FL" ) {
                            break;
                        }
                        else if ( element.listingDetails.listingStatus === "for_sale" || element.listingDetails.listingStatus === "pending" ) {
                            continue;
                        }
                        
                        const queryData = await queryATTOM(element.addressDetails.streetAddress, element.addressDetails.city, element.addressDetails.state, element.addressDetails.postalCode);
                        if ( queryData.status === 200 ) {
                            const amount = queryData.amount;
                            if ( amount === undefined ) {
                                continue;
                            }
                            else {
                                props[index].mlsVerified = true;
                                props[index].listingDetails.soldListingPrice = amount;
                            }
                        }
                        else {
                            continue;
                        }
                    }
                    return props;
                }
                else {
                    return props;
                }
            }
            else {
                return props;
            }
        };

        const getNeighbourhoodData = async() => {
			const neighbourhoodPath = `geo_output/map_neighborhood/county/${countyId}.json`;
			const params = {
				s3Data: {
					key: neighbourhoodPath,
					bucketName: "residentialpropertydata"
				},
				type: "s3"
			}
			const awsURL = process.env.REACT_APP_AWS_QUERY_URL;
			const queryData = await cloudFunctionV2(awsURL, params);
			if ( queryData.status === 200 ) {
				const body = queryData.body;
				setNeighbourhoodData(body);

				const newBounds = [];
				const getTracts = [];
				for (let index = 0; index < body.length; index++) {
					const element = body[index];
					getTracts.push(element.region.tractId);
					const tractPolygon = element.tractPolygon.flat(1);
					newBounds.push(tractPolygon);
				};
				setTracts(getTracts);
				setNeighbourhoodBounds(newBounds);
			}
		}

        const fetchSettings = async(newCompanyId) => {
            const colRef = "settings";
            const queryData = await getDocument(colRef, newCompanyId);
            if ( queryData.status === 200 ) {
                const data = queryData.data.data;
                return data;
            }
            else {
                return defaultSettings;
            }
        };

        const fetchPropertyData = async(savedUserId, savedCompanyId) => {
            const gatewayURL = process.env.REACT_APP_AWS_QUERY_URL;
            const resourceId = "propertyDetailV2";
            const propertyParams = {
                propertyId: propertyId,
                userId: savedUserId,
                countyId: countyId
            }
            const getGatewayQueryString = await propertyGatewayString("propertyDetailv2?", propertyParams);
            const getGatewayParams = {
                type: "gateway",
                resourceId: resourceId,
                queryString: getGatewayQueryString
            };
            const getGateway = await cloudFunctionV2(gatewayURL, getGatewayParams);
            if ( getGateway.status === 200 ) {
                const body = getGateway.body;
                const data = body.data;
                if ( body.error !== undefined ) {
                    alert(`Error: ${body.error}`);
                    return;
                }

                document.title = `${data.propertyDetails.addressDetails.streetAddress}, ${data.propertyDetails.addressDetails.city}, ${data.propertyDetails.addressDetails.state} ${data.propertyDetails.addressDetails.postalCode} | Clozers`;
                
                const salesComparables = data.salesComparables.comps;
                const recentlySold = salesComparables.recentlySold;
                const forSale = salesComparables.forSale;
                const fullList = recentlySold.concat(forSale);

                const amendedFullList = [];
                for (let index = 0; index < fullList.length; index++) {
                    const element = fullList[index].propertyDetails;
                    amendedFullList.push(element);
                }
                amendedFullList.sort((a, b) => b.compDetails.overallScore - a.compDetails.overallScore);
                const mlsAdjustedList = await getMLSData(savedCompanyId, amendedFullList);
                setAllComps(mlsAdjustedList);
                getNeighbourhoodData();

                await regenerateTimeline(mlsAdjustedList);

                setFilteredComps(mlsAdjustedList);

                if ( savedCompanyId !== null ) {
                    querySavedProperty(savedCompanyId, data.propertyDetails, mlsAdjustedList);
                }
                else {
                    setLoading(false);
                }
                setProperty(data.propertyDetails);
                setNetworkError(false);
            }
            else if ( getGateway.status === 405 ) {
                alert("Internal Server Error");
                setNetworkError(false);
                navigate("/");
                await sendErrorEmail({
                    userId: savedUserId,
                    address: "",
                    notes: "Comps Results page",
                    propertyId: propertyId
                });
            }
            else if ( getGateway.status === 406 ) {
                setNetworkError(true);
            }
            else {
                navigate("/");
                setNetworkError(false);
            }
        };

        /**
         * Cheap deep-equality check for the timeline arrays.
         * Firestore gives us plain JSON-serialisable objects, so stringify is fine.
         */
        const timelinesAreEqual = (t1, t2) => JSON.stringify(t1) === JSON.stringify(t2);

        const queryBestComps = async (newProperty, newAllComps, newCompanyId, newPropertyNotes, newADU, newPool, newGarage) => {
            // 1. Subscribe
            const ref = doc(db, 'companies', newCompanyId, 'properties', newProperty.uniqueIds.propertyId);
            const unsubscribe = onSnapshot(ref, async snap => {
                const data = snap.data().data;
                if (data.selectedComps && data.selectedComps.length > 0 && selectedComps.length === 0) {
                    setSelectedComps(data.selectedComps);
                    const fullCompList = await maxifyComps(data.selectedComps.map(e => e.zpid), newAllComps);
                    setBestComps(fullCompList);
                }

                if (
                    data.timeline !== undefined &&
                    !timelinesAreEqual(data.timeline, agenticStepsRef.current)
                ) {
                    setAgenticSteps(data.timeline);
                }

                if ( data.streetViewAnalysis !== undefined ) {
                    setStreetViewAnalysis(data.streetViewAnalysis);
                }
                
                if (data.arvMessages && data.arvMessages.length !== arvMessages.length) {
                    setArvMessages(data.arvMessages);
                    setTypeOutText(true);
                }

                if (data.anomaly) {
                    setAnomaly(data.anomaly);
                }

                if (data.redfinData) {
                    setRedfinData(data.redfinData);
                }
                
                if ( data.conditionUpdate ) {
                    // properties with updated conditions
                    setConditionUpdate(data.conditionUpdate);
                }

                if (data.arvData) {
                    if ( data.arvData.arv !== null ) {
                        setArvEstimate(data.arvData.arv);
                        setArvDescription(data.arvData.description);
                        setArvRange(data.arvData.arvRange);
                    }

                    if ( data.arvData.scenarios !== undefined && data.arvData.scenarios !== null && data.arvData.arv === null ) {
                        setActionRequired(true);
                    }
                    else {
                        setActionRequired(false);
                    }

                    if ( data.arvData.scenarios !== undefined && data.arvData.scenarios !== null ) {
                        setScenarios(data.arvData.scenarios);
                    }

                    if (data.excludedZPIDs) {
                        setExcludedZPIDs(data.excludedZPIDs);
                    }

                    if ( data.ceilings ) {
                        setCeilings(data.ceilings);
                    }

                    // All critical data received – we no longer need the snapshot listener.
                    unsubscribe();
                    setTypeOutText(true);
                }
            });
            // Kick off the long‑running Cloud Function without waiting for its HTTP
            // response. We rely on the Firestore listener above for progress/results.
            const getSettings = await fetchSettings(newCompanyId);
            startCompSelectionAgent(
                newAllComps,
                newProperty,
                newCompanyId,
                newProperty.uniqueIds.propertyId,
                newPropertyNotes,
                newADU,
                newPool,
                newGarage,
                getSettings,
                false,
                null
            ).catch(err => {
                // Prevent an unhandled‑promise rejection if the browser drops
                // the connection before the function responds.
                console.error("startCompSelectionAgent failed:", err);
            });
        }

        const querySavedProperty = async(newCompanyId, newProperty, newAllComps) => {
            const colRef = "companies";
            const docRef = newCompanyId;
            const subColRef = "properties";
            const subDocRef = newProperty.uniqueIds.propertyId;

            const queryData = await getSubDocument(colRef, docRef, subColRef, subDocRef);
            if ( queryData.status === 200 ) {
                const data = queryData.data.data;
                const newADU = data.adu === undefined ? false : data.adu;
                if ( newADU ) {
                    setAdu(true);
                }

                const newPool = data.pool === undefined ? false : data.pool;
                if ( newPool ) {
                    setPool(true);
                }

                const newGarage = data.garage === undefined ? false : data.garage;
                if ( newGarage ) {
                    setGarage(true);
                }

                if ( data.ceilings ) {
                    setCeilings(data.ceilings);
                }

                const newPropertyNotes = data.propertyNotes === undefined ? "" : data.propertyNotes;
                setPropertyNotes(newPropertyNotes);
                if ( data.selectedComps !== undefined ) {
                    
                    if ( data.selectedComps.length === 0 && data.anomaly === undefined ) {
                        queryBestComps(newProperty, newAllComps, newCompanyId, newPropertyNotes, newADU, newPool, newGarage);
                    }
                    else {
                        setSelectedComps(data.selectedComps);
                        const getFullComps = await maxifyComps(data.selectedComps.map(e => e.zpid), newAllComps);
                        setBestComps(getFullComps);
                    }
                }
                else {
                    queryBestComps(newProperty, newAllComps, newCompanyId, newPropertyNotes, newADU, newPool, newGarage);
                }

                if ( data.propertyDescriptions !== undefined ) {
                    setQualifyingDescriptions(data.propertyDescriptions);
                }

                if ( data.streetViewAnalysis !== undefined ) {
                    setStreetViewAnalysis(data.streetViewAnalysis);
                }

                if ( data.anomaly ) {
                    setAnomaly(data.anomaly);
                    setAgenticSteps(data.timeline);
                }

                if ( data.conditionUpdate ) {
                    setConditionUpdate(data.conditionUpdate);
                }

                if ( data.arvData !== undefined ) {
                    const compsList = data.arvData.comps;
                    let match = true;
                    for (let index = 0; index < data.selectedComps.length; index++) {
                        const element = data.selectedComps[index];
                        const zpid = element.zpid;
                        const zpidIndex = compsList.indexOf(zpid);
                        if ( zpidIndex === -1 ) {
                            match = false;
                        }
                    }
                    for (let index = 0; index < compsList.length; index++) {
                        const zpid = compsList[index];
                        const zpidIndex = data.selectedComps.findIndex(e => e.zpid === zpid);
                        if ( zpidIndex === -1 ) {
                            match = false;
                        }
                    }

                    if (data.redfinData) {
                        setRedfinData(data.redfinData);
                    }

                    if ( data.arvMessages !== undefined ) {
                        setArvMessages(data.arvMessages);
                        if ( data.arvData.scenarios !== undefined && data.arvData.scenarios !== null && data.arvData.arv === null ) {
                            setActionRequired(true);
                        }
                        else {
                            setActionRequired(false);
                            setArvEstimate(data.arvData.arv);
                            setArvDescription(data.arvData.description);
                            setArvRange(data.arvData.arvRange);
                            setCompsChanged(!match);
                        }

                        if ( data.arvData.scenarios !== undefined && data.arvData.scenarios !== null ) {
                            setScenarios(data.arvData.scenarios);
                        }

                        if ( data.timeline !== undefined ) {
                            setAgenticSteps(data.timeline);
                        }
                        setShowAgenticTimeline(false);
                    }
                    else {
                        queryBestComps(newProperty, newAllComps, newCompanyId, newPropertyNotes, newADU, newPool, newGarage);
                    }

                    if ( data.excludedZPIDs ) {
                        setExcludedZPIDs(data.excludedZPIDs);
                    }
                }

                if ( data.asIsData !== undefined ) {
                    const compsList = data.asIsData.comps;
                    let match = true;
                    for (let index = 0; index < data.selectedComps.length; index++) {
                        const element = data.selectedComps[index];
                        const zpid = element.zpid;
                        const zpidIndex = compsList.indexOf(zpid);
                        if ( zpidIndex === -1 ) {
                            match = false;
                        }
                    }
                    for (let index = 0; index < compsList.length; index++) {
                        const zpid = compsList[index];
                        const zpidIndex = data.selectedComps.findIndex(e => e.zpid === zpid);
                        if ( zpidIndex === -1 ) {
                            match = false;
                        }
                    }

                    if ( match === true ) {
                        setAsIsEstimate(data.asIsData.asIs);
                        setAsIsDescription(data.asIsData.description);
                    }
                }
                setLoading(false);
            }
            else {
                navigate("/");
            }
        };

        if ( (propertyId === null || countyId === null) ) {
            navigate("/");
        }
        else if ( property === null ) {
            fetchUserData();
        }

        const handleWindowResize = () => {
			setInnerWidth(window.innerWidth);
		};
	  
		window.addEventListener('resize', handleWindowResize);

    }, [
        navigate,
        countyId,
        property,
        propertyId,
        arvMessages,
        db,
        allComps,
        selectedComps.length
    ]);

    const showScrollableImages = (item) => {
        setImageViewProperty(item);
        setViewScrollableImages(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
        recordEvent("view_scrollable_images", {});
    };

    const closeScrollableImages = () => {
        setViewScrollableImages(false);
        recordEvent("close_scrollable_images", {});
    };

    const openImageGallery = (index) => {
        setImageViewPropertyIndex(index);
        setViewImageGallery(true);
        setViewScrollableImages(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
        recordEvent("open_image_gallery", {});
    };

    const closeImageGallery = () => {
        setViewImageGallery(false);
        setViewScrollableImages(true);
        setImageViewPropertyIndex(0);
        recordEvent("close_image_gallery", {});
    };

    const toggleSelectedComp = async(item) => {
        const cloneSelectedComps = [...selectedComps];
        const index = cloneSelectedComps.findIndex(e => e.zpid === item.uniqueIds.zillowId);
        if ( index === -1 && compTypeSelectionVal === null ) {
            openCompTypeModal(item);
            return;    
        }
        else if ( index === -1 && compTypeSelectionVal !== null ) {
            const zpid = item.uniqueIds.zillowId;
            const newObject = {
                zpid: zpid,
                type: compTypeSelectionVal,
                date: new Date()
            }
            cloneSelectedComps.push(newObject);
            recordEvent("keep_comp", {
                zpid: item.uniqueIds.zillowId
            });
        }
        else {
            cloneSelectedComps.splice(index, 1);
            recordEvent("remove_comp", {
                zpid: item.uniqueIds.zillowId
            });
        }
        setSelectedComps(cloneSelectedComps);

        if ( companyId !== null ) {
            const colRef = "companies";
            const docRef = companyId;
            const subColRef = "properties";
            const subDocRef = property.uniqueIds.propertyId;
            setSelectedPropertyTransaction(colRef, docRef, subColRef, subDocRef, cloneSelectedComps);
            setSelectedPropertyReportTransaction("reports", docRef, subColRef, subDocRef, cloneSelectedComps);
        }

        if ( cloneSelectedComps.length === 0 ) {
            setExpanded(false);
        }
        else {
            const remainingCompsInSection = cloneSelectedComps.filter(e => e.type === selectedPanel).length;
            if ( remainingCompsInSection === 0 ) {
                setSelectedPanel("all");
            }
        }
        setCompsChanged(true);
        closeCompTypeModal();

        if ( arvMessages.length >= 3 ) {
            const newMessages = [...arvMessages];
            if ( newMessages[newMessages.length - 1].role === "event" && newMessages[newMessages.length - 1].content === "Comps selection changed." ) {
            }
            else {
                const newObject = {
                    role: "event",
                    content: "Comps selection changed.",
                    date: new Date()
                };
                newMessages.push(newObject);
                setArvMessages(newMessages);

                if ( companyId !== null ) {
                    const colRef = "companies";
                    const docRef = companyId;
                    const subColRef = "properties";
                    const subDocRef = property.uniqueIds.propertyId;
                    await updatePropertyARVMessages(colRef, docRef, subColRef, subDocRef, newMessages);
                }
                setTypeOutText(true);
            }
        }
    };

    const autoKeepComps = () => {
        const cloneSelectedComps = [];
        for (let index = 0; index < bestComps.length; index++) {
            const element = bestComps[index];
            const zpid = element.uniqueIds.zillowId;
            const zpidIndex = cloneSelectedComps.findIndex(e => e.zpid === zpid);
            if ( zpidIndex === -1 ) {
                const newObject = {
                    zpid: zpid,
                    type: "arv",
                    date: new Date()
                }
                cloneSelectedComps.push(newObject);
            }
        }
        setSelectedComps(cloneSelectedComps);

        if ( companyId !== null ) {
            const colRef = "companies";
            const docRef = companyId;
            const subColRef = "properties";
            const subDocRef = property.uniqueIds.propertyId;
            setSelectedPropertyTransaction(colRef, docRef, subColRef, subDocRef, cloneSelectedComps);
            setSelectedPropertyReportTransaction("reports", docRef, subColRef, subDocRef, cloneSelectedComps);
        }
    };

    const getClickedMLSProperty = useCallback(async (prop) => {
        if ( prop.addressDetails.state === "FL" ) {
            return;
        }
        const colRef = "mls_data";
        const zipcode = prop.addressDetails.postalCode;   
        const subColRef = "properties";
        const subDocRef = prop.addressDetails.streetAddress;
        const soldListingDate = prop.listingDetails.soldListingDate;
        const soldListingDateTS = new Date(soldListingDate);
        const soldListingDateTSSeconds = Math.floor(soldListingDateTS.getTime() / 1000);

        const queryData = await getSubSubDocument(colRef, companyId, "zipcodes", zipcode, subColRef, subDocRef);
        if ( queryData.status === 200 ) {
            const price = queryData.data.price;
            const expiryDate = queryData.data.date;
            const expiryDateSeconds = expiryDate.seconds
            if ( soldListingDateTSSeconds < expiryDateSeconds ) {
                const allCompIndex = allComps.findIndex(e => e.uniqueIds.zillowId === prop.uniqueIds.zillowId);
                if ( allCompIndex !== -1 ) {
                    const compsClone = [...allComps];
                    compsClone[allCompIndex].mlsVerified = true;
                    compsClone[allCompIndex].listingDetails.soldListingPrice = price;
                    setAllComps(compsClone);
                }
            }
        }
    }, [companyId, allComps]);

    const openDetailedView = (item) => {
        setDetailedView(item);
        recordEvent("open_detailed_view", {
            zpid: item.uniqueIds.zillowId
        });
    };

    const closeDetailedView = () => {
        setDetailedView(null);
        recordEvent("close_detailed_view", {});
    };

    const onChangeZPIDHover = (id) => {
        setHoverZPID(id);
    };

    const viewComp = useCallback(async(item) => {
        const id = item.uniqueIds.zillowId;
        setClickedZPID(id);
        getClickedMLSProperty(item);

        const excludedZPIDIndex = excludedZPIDs.findIndex(e => e.zpid === id);
        const qualifyingDescriptionIndex = qualifyingDescriptions.findIndex(e => e.zpid === id);
        if ( excludedZPIDIndex !== -1 ) {
            const cloneQualifyingDescriptions = [...qualifyingDescriptions];
            const description = await getExclusionDescription(excludedZPIDs[excludedZPIDIndex], property, item);
            const newObject = {
                description: description,
                zpid: id
            };
            cloneQualifyingDescriptions.push(newObject);
            setQualifyingDescriptions(cloneQualifyingDescriptions);
        }
        else if ( qualifyingDescriptionIndex === -1 ) {
            const cloneQualifyingDescriptions = [...qualifyingDescriptions];
            const newObject = {
                description: "**Disqualifier -** This property was too far away from the subject property",
                zpid: id
            };
            cloneQualifyingDescriptions.push(newObject);
            setQualifyingDescriptions(cloneQualifyingDescriptions);
        }

        if ( innerWidth < 1000 ) {
            setCompsOverlayExpanded(true);

            if ( compsRefMobile.current !== null ) {
                setTimeout(() => {
                    compsRefMobile.current.scrollTo({
                        left: 200,
                        behavior: 'smooth'
                    });
                }, 250);
            }
        }

        if ( compsRef.current !== null ) {
            setTimeout(() => {
                compsRef.current.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 50);
        }
        recordEvent("comp_click", {
            zpid: id
        });
    }, [property, qualifyingDescriptions, innerWidth, getClickedMLSProperty, excludedZPIDs]);

    // const openShareLinkModal = () => {
    //     setShareLinkModal(true);
    // };

    // const closeShareLinkModal = () => {
    //     setShareLinkModal(false);
    // };

    const shareLink = async() => {
        const colRef = "companies";
        const docRef = companyId;
        const subColRef = "properties";
        const subDocRef = property.uniqueIds.propertyId;

        // Generate the link you want to copy
        const linkToCopy = `${window.location.origin}/comps/${docRef}/${countyId}/${subDocRef}`;
        try {
            await navigator.clipboard.writeText(linkToCopy);
            setLinkCopied(true);
            setLinkCopiedError(false);
        } 
        catch (err) {
            console.log("Clipboard copy failed:", err);
            setLinkCopiedError(true);
        }

        const queryData = await getSubDocument(colRef, docRef, subColRef, subDocRef);
        if ( queryData.status !== 200 ) {
            const newData = {
                loaded: true,
                propertyId: propertyId,
                countyId: countyId,
                address: {
                    streetAddress: property.addressDetails.streetAddress,
                    city: property.addressDetails.city,
                    state: property.addressDetails.state,
                    zipcode: property.addressDetails.postalCode,
                    label: `${property.addressDetails.streetAddress}, ${property.addressDetails.city}, ${property.addressDetails.state} ${property.addressDetails.postalCode}`
                },
                date: new Date(),
                selectedComps: selectedComps,
                userId: userId
            }
            await setSubData(colRef, docRef, subColRef, subDocRef, newData);
        }
        recordEvent("share_link", {});
    };

    const downloadProperties = async() => {
        setDownloadLoading(true);
        const url = process.env.REACT_APP_GENERATE_SPREADSHEET;
        
        const cloneSelectedComps = [...fullSelectedComps];
        for (let index = 0; index < cloneSelectedComps.length; index++) {
            const element = cloneSelectedComps[index];
            const selectedCompIndex = selectedComps.findIndex(e => e.zpid === element.uniqueIds.zillowId);
            if ( selectedCompIndex !== -1 ) {
                element.type = selectedComps[selectedCompIndex].type;
            }
            else {
                element.type = null;
            }    
        }

        const params = {
            userId: companyId,
            countyId: countyId,
            subjectProperty: property,
            comparables: cloneSelectedComps,
            downloadData: false,
            readOnly: false
        };

        const newWindow = window.open("", "_blank");
        const queryData = await cloudFunctionV2(url, params);
        if ( queryData.status === 200 ) {
            if ( newWindow === null ) {
                window.open(queryData.data, "_blank");
                newWindow.close();
            }
            else {
                newWindow.location.href = queryData.data;
            }
        }
        else {
            console.log("Error: ", queryData.error);
        }

        setDownloadLoading(false);
        recordEvent("download_properties", {});
    };

    const closeDropdowns = () => {
        setCompTypeDropdownOpen(null);
    };

    const openSearch = () => {
        setSearchOpen(true);
        recordEvent("open_search", {});
    };

    const closeSearch = () => {
        setSearchOpen(false);
    };

    const changeAddress = (text) => {
        setAddress(text);

        const newFilteredComps = [];
        for (let index = 0; index < allComps.length; index++) {
            const element = allComps[index];
            const streetAddress = element.addressDetails.streetAddress.toLowerCase();
            const fullAddress = `${streetAddress}, ${element.addressDetails.city.toLowerCase()}, ${element.addressDetails.state.toLowerCase()} ${element.addressDetails.postalCode}`;
            const searchAddress = text.toLowerCase();
            if ( fullAddress.includes(searchAddress) ) {
                const newObject = {
                    label: `${element.addressDetails.streetAddress}, ${element.addressDetails.city}, ${element.addressDetails.state} ${element.addressDetails.postalCode}`,
                    value: element.uniqueIds.zillowId
                }
                newFilteredComps.push(newObject);
            }
        };
        
        setSuggestedComps(text === "" ? [] : newFilteredComps);
    };

    const clickSuggestedComp = (item) => {
        const compIndex = allComps.findIndex(e => e.uniqueIds.zillowId === item.value);
        viewComp(allComps[compIndex]);
        setSuggestedComps([]);
        setAddress("");
    };

    const toggleMobileCompsList = () => {
        setCompsOverlayExpanded(!compsOverlayExpanded);
    };

    const toggleSettings = () => {
        setMobileSettings(true);
    };

    const closeSettings = () => {
        setMobileSettings(false);
    };

    const closeARVDescriptionModal = () => {
        recordEvent("close_arv_description_modal", {});
        setArvDescriptionModal(false);
    };
    
    const getARV = async() => {
        setArvLoading(true);

        const subjectPropertySubmission = await generateSubjectPropertyObject(property);
        const selectedCompSubmission = await generateSelectedCompsArray(fullSelectedComps, selectedComps, "arv");
        recordEvent("get_arv_estimate", {
            comps: selectedCompSubmission
        });
        const queryData = await generateARV(subjectPropertySubmission, selectedCompSubmission, ceilings, redfinData);
        if ( queryData.status === 200 ) {
            const rawData = queryData.data.replace(/```json|```/g, "").trim();
            try {
                const data = JSON.parse(rawData);
                setArvEstimate(data.arv);
                setArvDescription(data.description);
                setArvRange(data.arvRange);

                const newMessages = [...arvMessages];
                const newObject = {
                    role: "event",
                    content: "ARV Estimate Regenerated",
                    date: new Date()
                };
                const newArvObject = {
                    role: "assistant",
                    content: data.summary,
                    arvRange: data.arvRange,
                    expanded: data.description,
                    date: new Date()
                };
                newMessages.push(newObject);
                newMessages.push(newArvObject);
                setArvMessages(newMessages);
                setTypeOutText(true);

                if ( companyId !== null ) {
                    const colRef = "companies";
                    const docRef = companyId;
                    const subColRef = "properties";
                    const subDocRef = property.uniqueIds.propertyId;

                    const compZPIDs = selectedComps.map(e => e.zpid);
                    data.comps = compZPIDs;
                    setPropertyARVData(colRef, docRef, subColRef, subDocRef, data, newMessages);
                }
            } 
            catch (error) {
                console.error("Error parsing GPT JSON", error);
                console.log(rawData)
            }
        }
        else {
            console.log(queryData.error);
        }
        setArvLoading(false);
        setCompsChanged(false);
    };

    const getAsIs = async() => {
        setArvLoading(true);
        const subjectPropertySubmission = await generateSubjectPropertyObject(property);
        const selectedCompSubmission = await generateSelectedCompsArray(fullSelectedComps, selectedComps, "as-is");
        recordEvent("get_as-is_estimate", {
            comps: selectedCompSubmission
        });
        const queryData = await generateAsIs(subjectPropertySubmission, selectedCompSubmission);
        if ( queryData.status === 200 ) {
            const rawData = queryData.data.replace(/```json|```/g, "").trim();
            try {
                const data = JSON.parse(rawData);
                setAsIsEstimate(data.asIs);
                setAsIsDescription(data.description);

                if ( companyId !== null ) {
                    const colRef = "companies";
                    const docRef = companyId;
                    const subColRef = "properties";
                    const subDocRef = property.uniqueIds.propertyId;

                    const compZPIDs = selectedComps.map(e => e.zpid);
                    data.comps = compZPIDs;
                    setPropertyAsIsData(colRef, docRef, subColRef, subDocRef, data);
                }
            } 
            catch (error) {
                console.error("Error parsing GPT JSON", error);
                console.log(rawData)
            }
        }
        setArvLoading(false);
    };

    const showReRunReport = () => {
        setShowReRunReportModal(true);
    };

    const closeReRunReport = () => {
        setShowReRunReportModal(false);
    };

    const reRunReport = async() => {
        closeReRunReport();
        if ( companyId !== null && userId !== null ) {
            setReRunReportLoading(true);
            const reRunParams = {
                propertyId: propertyId,
                userId: userId,
                countyId: countyId
            };
            const resourceId = "propertyDetailV2";
            const getGatewayQueryString = await propertyGatewayStringReRun("propertyDetailv2?", reRunParams);
            const getGatewayParams = {
                type: "gateway",
                resourceId: resourceId,
                queryString: getGatewayQueryString
            };
            const gatewayURL = process.env.REACT_APP_AWS_QUERY_URL;
            cloudFunctionV2(process.env.REACT_APP_REMOVE_CREDIT, {companyId: companyId});
            
            const defaultPropertyData = await propertyData.property({
                property: property,
                userId: userId,
                propertyId: propertyId,
                countyId: countyId,
                propertyNotes: propertyNotes,
                adu: adu,
                pool: pool,
                garage: garage
            });
            await setSubData("companies", companyId, "properties", propertyId, defaultPropertyData);
            const queryData = await cloudFunctionV2(gatewayURL, getGatewayParams);
            if ( queryData.status === 200 ) {
                window.location.reload();
            }
            setReRunReportLoading(false);
        }
    };

    const onChangeARVDescriptionPrompt = (val) => {
        setArvDescriptionPrompt(val);
    };

    const submitARVPrompt = async() => {
        const now = new Date();
        const url = process.env.REACT_APP_AGENTIC_CHATBOT;
        const minifiedBestComps = await minifyComps(bestComps);
        const minifiedAllComps = await minifyComps(allComps);
        const minifiedSubjectProperty = await generateSubjectPropertyObject(property);
        const newArvMessages = [
            ...arvMessages,
            { role: "user_chat", content: arvDescriptionPrompt, date: now }
        ];
        const params = {
            arvMessages: newArvMessages,
            companyId: companyId,
            propertyId: propertyId,
            text: arvDescriptionPrompt,
            triageModel: "gpt-4o-mini",
            filterSetupModel: "gpt-4.1-mini-2025-04-14",//"gpt-4o-mini",
            subjectProperty: minifiedSubjectProperty,
            fullSubjectProperty: property,
            bestComps: minifiedBestComps,
            allComps: minifiedAllComps,
            reasoningModel: "o3",
            actionRequired: actionRequired,
            scenarios: scenarios,
            arv: arvEstimate,
            arvRange: arvRange,
            excludedZPIDs: excludedZPIDs
        }
        setChatbotLoading(true);
        setTypeOutText(true);
        setArvMessages(newArvMessages);
        setArvDescriptionPrompt("");
        await listenForARVMessages(
            companyId,
            propertyId,
            setArvMessages,
            setArvEstimate,
            setArvDescription,
            setArvRange,
            url,
            params,
            newArvMessages,
            arvEstimate,
            allComps,
            viewComp,
            setTypeOutText
        );
        setChatbotLoading(false);
        setActionRequired(false);
    };

    const allCompsMapProps = useMemo(() => ({
        subjectProperty: property,
        comps: filteredComps,
        isMapLoaded: isLoaded,
        clickedZPID,
        viewComp,
        bestComps,
        hoverZPID,
        neighbourhoodData,
        tracts,
        neighbourhoodBounds,
        hoverMapLegend,
        setHoverMapLegend,
        showHeatmap,
        readOnly,
        compTypeLegend: null,
        innerWidth,
        mapType,
        setMapType,
        rawMap,
        setRawMap,
        setSubjectPropertyHover,
        ceilings,
        selectedComps
    }), [
        property,
        filteredComps,
        isLoaded,
        clickedZPID,
        viewComp,
        bestComps,
        hoverZPID,
        neighbourhoodData,
        tracts,
        neighbourhoodBounds,
        hoverMapLegend,
        showHeatmap,
        readOnly,
        innerWidth,
        mapType,
        rawMap,
        setHoverMapLegend,
        setMapType,
        setRawMap,
        setSubjectPropertyHover,
        ceilings,
        selectedComps
    ]);

    const selectScenario = async(optimistic) => {
        const newArvMessages = [...arvMessages];
        const newObject = {
            role: "event",
            content: `${optimistic ? "Optimistic" : "Conservative"} strategy selected`,
            date: new Date()
        };
        newArvMessages.push(newObject);
        setArvMessages(newArvMessages);
        setActionRequired(false);
        const relevantScenario = optimistic ? scenarios.optimistic : scenarios.conservative;
        setArvEstimate(relevantScenario.arv);
        setArvDescription(relevantScenario.description);
        setArvRange(relevantScenario.arvRange);

        if ( companyId !== null ) {
            await selectARVScenario("companies", companyId, "properties", propertyId, newArvMessages, {
                arv: relevantScenario.arv,
                arvRange: relevantScenario.arvRange,
                description: relevantScenario.description
            }, optimistic);
        }
    };

    const openCompTypeModal = (item) => {
        setCompTypeModal(true);
        setKeptComp(item);
        const propertyCondition = item.compDetails.propertyCondition;

        if ( 
            propertyCondition === "Recently Remodeled"
        ) {
            setCompTypeSelectionVal("arv");
        }
    };

    const closeCompTypeModal = () => {
        setCompTypeModal(false);
        setCompTypeSelectionVal(null);
        setKeptComp(null);
    };

    const closeARVErrorModal = () => {
        setRegenerateARVErrorModal(false);
    };

    const openMissingCompModal = () => {
        recordEvent("open_missing_comp_modal", {
            address: address
        });
        setMissingCompModal(true);
        setSearchOpen(false);
    };

    const closeMissingCompModal = () => {
        setMissingCompModal(false);
        setAddress("");
        setMissingCompDescription("");
    };

    const submitMissingComp = async() => {
        if ( companyId !== null ) {
            setMissingCompLoading(true);
            const colRef = "missing_comps";
            const docRef = companyId;
            const subColRef = "properties";
            const subDocRef = await makeId(10);
            const newData = {
                propertyId: propertyId,
                countyId: countyId,
                address: address,
                description: missingCompDescription,
                date: new Date(),
                userId: userId,
                url: `https://app.clozers.co/run-comps/${countyId}/${propertyId}`
            };
            await setSubData(colRef, docRef, subColRef, subDocRef, newData);
            newData.companyId = companyId;
            const url = process.env.REACT_APP_SEND_EMAIL;
            const params = {
                data: newData,
                dynamicTemplateId: "d-d017516f67144419a823e31a4bedf59f"
            };
            await cloudFunctionV2(url, params);
            recordEvent("submit_missing_comp", {
                address: address
            });
            setMissingCompLoading(false);
        }
        closeMissingCompModal();
    };

    const openAgenticAnalysis = () => {
        recordEvent("open_agentic_analysis", {});
        setShowAgenticTimeline(true);
    };

    return (
        <div className={"run-comps-outer-container " + (darkBgActive === true ? "relative-container " : "") + (reRunReportLoading === true ? "bg-colour-black" : "")}>
            <Header
                loggedIn={loggedIn}
                showTimeline={reRunReportLoading === true ? true : showAgenticTimeline}
            />
            {
                showAgenticTimeline === true &&
                <AgenticTimeline
                    steps={agenticSteps}
                    streetViewAnalysis={streetViewAnalysis}
                    actionRequired={actionRequired}
                    selectScenario={selectScenario}
                    scenarios={scenarios}
                    textFinished={() => setTypeOutText(false)}
                    typeOutText={typeOutText}
                    setShowAgenticTimeline={setShowAgenticTimeline}
                    finished={arvEstimate !== null || scenarios !== null ? true : false}
                    innerWidth={innerWidth}
                    allComps={allComps}
                    property={property}
                    anomaly={anomaly}
                    redfinData={redfinData}
                    continueAgenticFlow={null}
                    showScrollableImages={showScrollableImages}
                />
            }
            {
                viewImageGallery === true && imageViewProperty !== null &&
                <ImageGallery
                    alt={imageViewProperty.addressDetails.streetAddress}
                    images={imageViewProperty.listingDetails.mlsPhotoUrls}
                    imageIndex={imageViewPropertyIndex}
                    setImageIndex={setImageViewPropertyIndex}
                    closeImageGallery={closeImageGallery}
                />
            }
            {
                viewScrollableImages === true && imageViewProperty !== null &&
                <ScrollableImages
                    images={imageViewProperty.listingDetails.mlsPhotoUrls}
                    closeScrollableImages={closeScrollableImages}
                    imageClick={openImageGallery}
                />
            }
            {
                loading === false && reRunReportLoading === false &&
                <SelectedComps
                    allSelectedComps={selectedComps}
                    setAllSelectedComps={setSelectedComps}
                    fullSelectedComps={fullSelectedComps}
                    toggleSelectedComp={toggleSelectedComp}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    showScrollableImages={showScrollableImages}
                    openDetailedView={openDetailedView}
                    downloadProperties={downloadProperties}
                    shareLink={shareLink}
                    downloadLoading={downloadLoading}
                    selectedPanel={selectedPanel}
                    setSelectedPanel={setSelectedPanel}
                    compTypeDropdownOpen={compTypeDropdownOpen}
                    setCompTypeDropdownOpen={setCompTypeDropdownOpen}
                    closeDropdowns={closeDropdowns}
                    companyId={companyId}
                    property={property}
                    linkCopied={linkCopied}
                    linkCopiedError={linkCopiedError}
                    readOnly={readOnly}
                    compTypeLegend={null}
                    isLoaded={isLoaded}
                    bestComps={bestComps}
                    innerWidth={innerWidth}
                    getARV={getARV}
                    arvLoading={arvLoading}
                    arvEstimate={arvEstimate}
                    arvDescription={arvDescription}
                    getAsIs={getAsIs}
                    asIsEstimate={asIsEstimate}
                    asIsDescription={asIsDescription}
                    onboardingStep={null}
                    nextOnboardingStep={null}
                    mobileSelectedCompsBody={mobileSelectedCompsBody}
                    autoKeepComps={autoKeepComps}
                    setArvDescriptionModal={setArvDescriptionModal}
                    compsChanged={compsChanged}
                    setRegenerateARVErrorModal={setRegenerateARVErrorModal}
                    actionRequired={actionRequired}
                    setSmallChatExpanded={null}
                    bodyRef={bodyRef}
                />
            }
            {
                selectedComps.length > 0 && loading === false &&
                <MobileSelectedComps
                    allSelectedComps={selectedComps}
                    setAllSelectedComps={setSelectedComps}
                    fullSelectedComps={fullSelectedComps}
                    toggleSelectedComp={toggleSelectedComp}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    showScrollableImages={showScrollableImages}
                    openDetailedView={openDetailedView}
                    downloadProperties={downloadProperties}
                    shareLink={shareLink}
                    downloadLoading={downloadLoading}
                    selectedPanel={selectedPanel}
                    setSelectedPanel={setSelectedPanel}
                    compTypeDropdownOpen={compTypeDropdownOpen}
                    setCompTypeDropdownOpen={setCompTypeDropdownOpen}
                    closeDropdowns={closeDropdowns}
                    companyId={companyId}
                    property={property}
                    linkCopied={linkCopied}
                    linkCopiedError={linkCopiedError}
                    readOnly={readOnly}
                    compTypeLegend={null}
                    isLoaded={isLoaded}
                    bestComps={bestComps}
                    innerWidth={innerWidth}
                    getARV={getARV}
                    arvLoading={arvLoading}
                    arvEstimate={arvEstimate}
                    arvDescription={arvDescription}
                    getAsIs={getAsIs}
                    asIsEstimate={asIsEstimate}
                    asIsDescription={asIsDescription}
                    onboardingStep={null}
                    nextOnboardingStep={null}
                    mobileSelectedCompsBody={mobileSelectedCompsBody}
                />
            }
            {
                detailedView !== null &&
                <PropertyCardDetail
                    property={detailedView}
                    selected={selectedComps.findIndex(e => e.zpid === detailedView.uniqueIds.zillowId) !== -1 ? true : false}
                    closeDetailedView={closeDetailedView}
                    toggleSelectedComp={toggleSelectedComp}
                    showScrollableImages={showScrollableImages}
                    isLoaded={isLoaded}
                    subjectProperty={property}
                    clickedCompDescription={clickedCompDescription}
                    readOnly={readOnly}
                    loading={loading}
                    bestComp={bestComps.findIndex(e => e.uniqueIds.zillowId === detailedView.uniqueIds.zillowId) !== -1 ? true : false}
                    conditionUpdate={conditionUpdate}
                />
            }
            {
                darkBgActive === true &&
                <div className="dark-bg">
                </div>
            }
            {
                showReRunReportModal === true &&
                <Modal
                    heading="Re-run this report?"
                    subheading={"Check for newly sold listings."}
                    body={<span className="body-regular colour-primary">Are you sure you want to re-run this report? It will cost you <span className="body-bold">1 credit.</span></span>}
                    type="basic"
                    cancelText={"Cancel"}
                    cancelButtonCTA={closeReRunReport}
                    actionButtonText={"Yes, Re-run"}
                    actionButtonCTA={reRunReport}
                    secondaryButtonText={null}
                    secondaryButtonCTA={null}
                    exitButtonCTA={closeReRunReport}
                    loading={false}
                    actionButtonDisabled={false}
                    leftIcon={null}
                    rightIcon={null}
                    cancelLeftIcon={null}
                    cancelRightIcon={null}
                    customClass="re-run-report-modal"
                />
            }
            {
                mobileSettings === true && innerWidth < 1000 &&
                    <Modal
                        heading="Settings"
                        subheading={null}
                        body={<MobileSettings showHeatmap={showHeatmap} setShowHeatmap={setShowHeatmap} mapType={mapType} setMapType={setMapType} neighbourhoodData={neighbourhoodData} rawMap={rawMap} compTypeOptions={null} handleCompTypeSelection={null} />}
                        type="none"
                        cancelText={null}
                        cancelButtonCTA={closeSettings}
                        actionButtonText={null}
                        actionButtonCTA={null}
                        secondaryButtonText={null}
                        secondaryButtonCTA={null}
                        exitButtonCTA={closeSettings}
                        loading={false}
                        actionButtonDisabled={false}
                        leftIcon={null}
                        rightIcon={null}
                        cancelLeftIcon={null}
                        cancelRightIcon={null}
                        customClass=""
                    />
            }
            {
                arvDescriptionModal === true &&
                <Modal
                    heading="ARV Estimate reasoning"
                    subheading={null}
                    subheadingComponent={<ARVEstimateHeading arvEstimate={arvEstimate} arvRange={arvRange} />}
                    body={<ARVEstimateDescription arvDescription={arvDescription} arvMessages={arvMessages} loading={chatbotLoading} textAreaHeight={textAreaHeight} compsChanged={compsChanged} getARV={getARV} arvLoading={arvLoading} typeOutText={typeOutText} setTypeOutText={setTypeOutText} readOnly={readOnly} scenarios={scenarios} actionRequired={actionRequired} selectScenario={selectScenario} />}
                    type={"none"}
                    cancelText={null}
                    cancelButtonCTA={closeARVDescriptionModal}
                    actionButtonText={"Close"}
                    actionButtonCTA={closeARVDescriptionModal}
                    secondaryButtonText={null}
                    secondaryButtonCTA={null}
                    exitButtonCTA={closeARVDescriptionModal}
                    loading={arvLoading === true ? true : chatbotLoading === true ? true : false}
                    actionButtonDisabled={false}
                    leftIcon={null}
                    rightIcon={null}
                    cancelLeftIcon={null}
                    cancelRightIcon={null}
                    customClass="arv-estimate-modal"
                    promptInput={true}
                    prompt={arvDescriptionPrompt}
                    onChangePrompt={(e) => onChangeARVDescriptionPrompt(e.target.value)}
                    submitPrompt={() => submitARVPrompt()}
                    arvMessages={arvMessages}
                    setTextAreaHeight={setTextAreaHeight}
                />
            }
            {
                compTypeModal === true &&
                    <Modal
                        heading="What type of comp is it?"
                        subheading={null}
                        body={<CompTypeSelection compTypeSelectionVal={compTypeSelectionVal} setCompTypeSelectionVal={setCompTypeSelectionVal} />}
                        type="basic"
                        cancelText={"Cancel"}
                        cancelButtonCTA={closeCompTypeModal}
                        actionButtonText={"Save"}
                        actionButtonCTA={() => toggleSelectedComp(keptComp)}
                        secondaryButtonText={null}
                        secondaryButtonCTA={null}
                        exitButtonCTA={closeCompTypeModal}
                        loading={false}
                        actionButtonDisabled={compTypeSelectionVal === null ? true : false}
                        leftIcon={null}
                        rightIcon={null}
                        cancelLeftIcon={null}
                        cancelRightIcon={null}
                        customClass="comp-type-selection-modal"
                    />
            }
            {
                missingCompModal === true &&
                    <Modal
                        heading="Report missing comp"
                        subheading={null}
                        body={<MissingComp address={address} setAddress={setAddress} missingCompDescription={missingCompDescription} setMissingCompDescription={setMissingCompDescription} />}
                        type="basic"
                        cancelText={"Cancel"}
                        cancelButtonCTA={closeMissingCompModal}
                        actionButtonText={"Save"}
                        actionButtonCTA={() => submitMissingComp()}
                        secondaryButtonText={null}
                        secondaryButtonCTA={null}
                        exitButtonCTA={closeMissingCompModal}
                        loading={false}
                        actionButtonDisabled={missingCompLoading === true || address === "" || missingCompDescription === "" ? true : false}
                        leftIcon={null}
                        rightIcon={null}
                        cancelLeftIcon={null}
                        cancelRightIcon={null}
                        customClass="comp-type-selection-modal"
                    />
            }
            {/* {
                soldCompModal === true &&
                    <Modal
                        heading="Not many sold comps.."
                        subheading={null}
                        body={<SoldCompModalBody extraSoldComps={extraSoldComps} soldCompDisqualifiers={soldCompDisqualifiers} bestComps={bestComps} property={property} isLoaded={isLoaded} toggleSelectedComp={toggleSelectedComp} selectedComps={selectedComps} />}
                        type="basic"
                        cancelText={"Cancel"}
                        cancelButtonCTA={closeSoldCompModal}
                        actionButtonText={"Generate ARV"}
                        actionButtonCTA={() => soldCompsModalARV()}
                        secondaryButtonText={null}
                        secondaryButtonCTA={null}
                        exitButtonCTA={closeSoldCompModal}
                        loading={false}
                        actionButtonDisabled={false}
                        leftIcon={<Wand fill={colour.gray00} className="selected-comps-wand" />}
                        rightIcon={null}
                        cancelLeftIcon={null}
                        cancelRightIcon={null}
                        customClass="sold-comps-modal-container"
                    />
            } */}
            {
                regenerateARVErrorModal === true &&
                    <Modal
                        heading={compsChanged === false ? "No changes detected" : "Select more comps"}
                        subheading={null}
                        body={
                            compsChanged === false ?
                            <span className="body-regular colour-primary">
                                Your comps selection has not changed since the last time you generated an ARV estimate. 
                                Keep or remove a comp to generate a new estimate.
                            </span>
                            :
                            <span className="body-regular colour-primary">
                                You only have 1 kept ARV comp. You need at least <span className="body-bold">2 kept ARV comps</span> to generate an ARV estimate.
                            </span>
                        }
                        type="single"
                        cancelText={null}
                        cancelButtonCTA={closeARVErrorModal}
                        actionButtonText={"Got it"}
                        actionButtonCTA={closeARVErrorModal}
                        secondaryButtonText={null}
                        secondaryButtonCTA={null}
                        exitButtonCTA={closeARVErrorModal}
                        loading={false}
                        actionButtonDisabled={false}
                        leftIcon={null}
                        rightIcon={null}
                        cancelLeftIcon={null}
                        cancelRightIcon={null}
                        customClass="regenerate-arv-error-modal"
                    />
            }
            {
                loading === true &&
                <Loading />
            }
            {
                reRunReportLoading === true ?
                <div className="run-comps-inner-container">
                    <ReportLoadingAnimation />
                </div>
                :
                networkError === true ?
                <div className="run-comps-inner-container">
                    <div className="run-comps-header-container">
                        <h1 className="heading-large-bold colour-primary text-align-center">
                            Network error
                        </h1>
                        <span className="body-regular colour-primary block-text text-align-center">
                            There was an error connecting to the network. Please try again later.
                        </span>
                    </div>
                </div>
                :
                property === null || loading === true ?
                <div className="run-comps-inner-container">
                </div>
                :
                <div className="run-comps-inner-container">
                    <div 
                        className="run-comps-body-container"
                        ref={bodyRef}
                    >
                        <div className="run-comps-header-outer-container">
                            <div className="run-comps-header-container mobile-none">
                                <div className="run-comps-header-left-container">
                                    {
                                        agenticSteps.length > 0 &&
                                        <div 
                                            className="text-button button-row gap-x-small no-underline mobile-none"
                                            onClick={() => openAgenticAnalysis()}
                                        >
                                            <LicenseIcon
                                                size={16}
                                                color={colour.gray06}
                                            />
                                            <span className="body-regular colour-primary">
                                                Open analysis
                                            </span>
                                        </div>
                                    }
                                    <IconButton
                                        size="medium"
                                        icon={<ReloadIcon color={colour.gray06} size={16} />}
                                        disabled={false}
                                        clickFunc={showReRunReport}
                                        standardIcon={false}
                                        background={true}
                                        bgType={"white"}
                                        contextTooltip={true}
                                        contextTooltipBG={"dark"}
                                        contextTooltipText={"Re-run report"}
                                        customClass={null}
                                    />
                                    {
                                        filteredComps.length === allComps.length ?
                                        <span className="body-regular colour-primary">
                                            Showing <span className="body-bold">{filteredComps.length}</span> comps
                                        </span>
                                        :
                                        <span className="body-regular colour-primary">
                                            Showing <span className="body-bold">{filteredComps.length}</span> of {allComps.length} comps
                                        </span>
                                    }
                                </div>
                                <div className="run-comps-header-right-container">
                                    {
                                        searchOpen === true ?
                                        <div className="run-comps-header-search-input-container relative-container">
                                            <SearchInput
                                                value={address}
                                                onChange={(text) => changeAddress(text.target.value)}
                                                placeholder="Search"
                                                type="text"
                                                clearInput={() => changeAddress("")}
                                                magnifyingGlassFunc={() => closeSearch()}
                                                disabled={false}
                                            />
                                            {
                                                suggestedComps.length > 0 ?
                                                <PredictiveSearch
                                                    loading={false}
                                                    results={suggestedComps}
                                                    selectItem={(item) => clickSuggestedComp(item)}
                                                    nested={false}
                                                />
                                                :
                                                null
                                            }
                                        </div>
                                        :
                                        <div 
                                            className="text-button button-row gap-x-small"
                                            onClick={() => openSearch()}
                                        >
                                            <MagnifyingGlass
                                                fill={colour.gray05}
                                                className=""
                                                clickFunc={null}
                                            />
                                            <span className="body-regular colour-primary">
                                                Search
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                            {
                                address.trim() !== "" && suggestedComps.length === 0 && innerWidth > 1000 &&
                                    <div className="run-comps-missing-comp-container">
                                        <span className="body-regular colour-error">
                                            Address not found
                                        </span>
                                        <span className="body-regular colour-secondary">
                                            This address wasn't included in our 200+ comps analyzed — 
                                            likely because it sold too long ago or wasn't similar enough 
                                            to the subject property. Think it's a mistake?{" "}
                                            <span 
                                                className="colour-primary cursor-pointer underline"
                                                onClick={() => openMissingCompModal()}
                                            >
                                                Report an issue
                                            </span>
                                        </span>
                                    </div>
                            }
                        </div>
                        <div className="run-comps-mobile-header-container desktop-none">
                            <div className="run-comps-mobile-header-left-container">
                                <div className="run-comps-mobile-header-button-container">
                                    <Button
                                        buttonType="secondary-button"
                                        size="large"
                                        text={compsOverlayExpanded === true ? "Map view" : "Comps list"}
                                        cta={toggleMobileCompsList}
                                        disabled={false}
                                        leftIcon={compsOverlayExpanded === false ? <House className="" fill={colour.gray06} /> : <Location04Icon size={16} color={colour.gray06} />}
                                        leftIconClass=""
                                        rightIcon={null}
                                        rightIconClass=""
                                        alt=""
                                        standardIcon={false}
                                        badge={false}
                                        badgeVal={null}
                                        badgeBG={null}
                                        buttonRef={null}
                                        spinner={false}
                                    />
                                </div>
                                {
                                    agenticSteps.length > 0 &&
                                    <div 
                                        className="text-button button-row gap-x-small no-underline"
                                        onClick={() => openAgenticAnalysis()}
                                    >
                                        <LicenseIcon
                                            size={16}
                                            color={colour.gray06}
                                        />
                                        <span className="body-regular colour-primary">
                                            Analysis
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className="run-comps-mobile-header-button-container">
                                <IconButton
                                    size="large"
                                    icon={<Settings01Icon color={colour.gray06} size={24} />}
                                    disabled={false}
                                    clickFunc={toggleSettings}
                                    standardIcon={false}
                                    background={true}
                                    bgType={"white"}
                                    contextTooltip={false}
                                    contextTooltipBG={null}
                                    contextTooltipText={null}
                                    customClass={null}
                                />
                            </div>
                        </div>
                        <div className="run-comps-inner-body-container">
                            <div className="run-comps-map-container">
                                <AllCompsMap {...allCompsMapProps} />
                                {
                                    neighbourhoodData !== null && innerWidth >= 1000 &&
                                    <div className={"run-comp-map-bottom-container " + (showHeatmap === false ? "run-comp-hide-heatmap" : "")}>
                                        <MapLegend
                                            hoverMapLegend={hoverMapLegend}
                                            setHoverMapLegend={setHoverMapLegend}
                                            neighbourhoodOption={0}
                                        />
                                        <Switch
                                            label={"Heatmap"}
                                            val={showHeatmap}
                                            setVal={setShowHeatmap}
                                        />
                                    </div>
                                }
                            </div>
                            <div className={"run-comps-subject-property-section mobile-none " + (subjectPropertyHover === true ? "run-comps-subject-property-section-hover" : "")}>
                                <div className="run-comps-subject-property-title-container">
                                    <div className="relative-container">
                                        <MapBubble
                                            className=""
                                            fill={colour.gray07}
                                            stroke={colour.gray00}
                                            strokeWidth="0.5"
                                        />
                                        <House
                                            fill={colour.gray00}
                                            className="all-comps-map-house-icon"
                                        />
                                    </div>
                                    <span className="body-bold colour-primary">
                                        Subject property
                                    </span>
                                </div>
                                <PropertyCard
                                    property={property}
                                    subjectProperty={true}
                                    subjectPropertyObject={property}
                                    showScrollableImages={showScrollableImages}
                                    detail={false}
                                    isLoaded={isLoaded}
                                    testView={false}
                                    alwaysActive={true}
                                    selected={false}
                                    toggleSelectedComp={null}
                                    bestComp={false}
                                    openDetailedView={null}
                                    clickedZPID={clickedZPID}
                                    clickedCompDescription={null}
                                    loading={false}
                                    onChangeZPIDHover={null}
                                    readOnly={readOnly}
                                    innerWidth={innerWidth}
                                    subjectPropertyHover={subjectPropertyHover}
                                    gptLoading={false}
                                    priceCeiling={false}
                                    priceCeilingText={null}
                                    darkMode={false}
                                    conditionUpdate={[]}
                                />
                            </div>
                            <div 
                                className="run-comps-cards-section mobile-none"
                                ref={compsRef}
                            >
                                {
                                    clickedZPID !== null &&
                                    <PropertyCard
                                        property={clickedComp}
                                        subjectProperty={false}
                                        subjectPropertyObject={property}
                                        showScrollableImages={showScrollableImages}
                                        isLoaded={isLoaded}
                                        testView={false}
                                        alwaysActive={true}
                                        selected={selectedComps.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                                        toggleSelectedComp={() => toggleSelectedComp(clickedComp)}
                                        bestComp={bestComps.findIndex(e => e.uniqueIds.zillowId === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                                        openDetailedView={openDetailedView}
                                        clickedZPID={clickedZPID}
                                        clickedCompDescription={clickedCompDescription}
                                        loading={loading}
                                        onChangeZPIDHover={null}
                                        readOnly={readOnly}
                                        innerWidth={innerWidth}
                                        subjectPropertyHover={false}
                                        gptLoading={false}
                                        priceCeiling={ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? true : false}
                                        priceCeilingText={ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId) !== -1 ? ceilings[ceilings.findIndex(e => e.zpid === clickedComp.uniqueIds.zillowId)].description : null}
                                        darkMode={false}
                                        conditionUpdate={conditionUpdate}
                                    />
                                }
                                {
                                    bestComps.length > 0 &&
                                    <div className="run-comps-best-comps-title-container">
                                        <div className="relative-container">
                                            <MapBubble
                                                className=""
                                                fill={colour.jade01}
                                                stroke={colour.jade02}
                                                strokeWidth="0.5"
                                            />
                                            <House
                                                fill={colour.jade03}
                                                className="all-comps-map-house-icon"
                                            />
                                        </div>
                                        <span className="body-bold colour-primary">
                                            Suggested comps
                                        </span>
                                    </div>
                                }
                                {
                                    bestComps.map((item, index) =>
                                        item.uniqueIds.zillowId !== clickedZPID &&
                                        <PropertyCard
                                            property={item}
                                            subjectProperty={false}
                                            subjectPropertyObject={property}
                                            showScrollableImages={showScrollableImages}
                                            isLoaded={isLoaded}
                                            key={index}
                                            testView={false}
                                            alwaysActive={true}
                                            selected={selectedComps.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? true : false}
                                            toggleSelectedComp={() => toggleSelectedComp(item)}
                                            bestComp={true}
                                            openDetailedView={openDetailedView}
                                            clickedZPID={clickedZPID}
                                            clickedCompDescription={null}
                                            loading={false}
                                            onChangeZPIDHover={onChangeZPIDHover}
                                            readOnly={readOnly}
                                            innerWidth={innerWidth}
                                            subjectPropertyHover={false}
                                            gptLoading={false}
                                            priceCeiling={ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? true : false}
                                            priceCeilingText={ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId) !== -1 ? ceilings[ceilings.findIndex(e => e.zpid === item.uniqueIds.zillowId)].description : null}
                                            darkMode={false}
                                            conditionUpdate={conditionUpdate}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <CompsOverlay
                            expanded={compsOverlayExpanded}
                            property={property}
                            showScrollableImages={showScrollableImages}
                            isLoaded={isLoaded}
                            clickedZPID={clickedZPID}
                            readOnly={readOnly}
                            compsRef={compsRefMobile}
                            clickedComp={clickedComp}
                            bestComps={bestComps}
                            selectedComps={selectedComps}
                            loading={loading}
                            clickedCompDescription={clickedCompDescription}
                            toggleSelectedComp={toggleSelectedComp}
                            openDetailedView={openDetailedView}
                            onChangeZPIDHover={onChangeZPIDHover}
                            innerWidth={innerWidth}
                            filteredComps={filteredComps}
                            allComps={allComps}
                            compTypeLegend={null}
                            gptLoading={false}
                            ceilings={ceilings}
                            conditionUpdate={conditionUpdate}
                        />
                    </div>
                    <SmallChat
                        arvDescription={arvDescription} 
                        arvMessages={arvMessages} 
                        loading={chatbotLoading} 
                        textAreaHeight={textAreaHeight} 
                        compsChanged={compsChanged} 
                        getARV={getARV} 
                        arvLoading={arvLoading} 
                        typeOutText={typeOutText} 
                        setTypeOutText={setTypeOutText} 
                        readOnly={readOnly}
                        arvDescriptionPrompt={arvDescriptionPrompt}
                        onChangePrompt={(e) => onChangeARVDescriptionPrompt(e.target.value)}
                        submitPrompt={() => submitARVPrompt()}
                        setTextAreaHeight={setTextAreaHeight}
                        setArvDescriptionModal={setArvDescriptionModal}
                        arvEstimate={arvEstimate}
                        arvRange={arvRange}
                        expanded={smallChatExpanded}
                        setExpanded={setSmallChatExpanded}
                        smallChatHover={smallChatHover}
                        setSmallChatHover={setSmallChatHover}
                        smallChatHoverText={"Want some clarification?"}
                        scenarios={scenarios}
                        actionRequired={actionRequired}
                        selectScenario={selectScenario}
                        innerWidth={innerWidth}
                        anomaly={anomaly}
                        redfinData={redfinData}
                    />
                </div>
            }
        </div>
    )
};

export default RunComps;